import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { ButtonBaseComponent } from '../button-base.component';

@Component({
  selector: 'nibtravel-button-link',
  templateUrl: 'button-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonLinkComponent extends ButtonBaseComponent {
  @HostBinding('class') class = 'btn-link-host';
  @Input() href!: string;
}
